// import React from "react";
// import { Navigate } from "react-router-dom";

// const ProtectedRoute = ({ admin, disallowedRoles = [], children }) => {
//   if (!admin || disallowedRoles.includes(admin.role)) {
//     return <Navigate to="/" replace />;
//   }
//   return children;
// };

// export default ProtectedRoute;



import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({
  admin,
  allowedRoles,
  disallowedRoles = ["ticket-admin","earnings-report-only"],
  children,
}) => {
  if (!admin) {
    return <Navigate to="/" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(admin.role)) {
    return <Navigate to="/not-authorized" replace />;
  }

  if (disallowedRoles.includes(admin.role)) {
    return <Navigate to="/not-authorized" replace />;
  }

  return children;
};

export default ProtectedRoute;

